import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faTwitter,
	faFacebookF,
	faInstagram,
	faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import {
	faArrowRight,
	faPhone,
	faEnvelope,
	faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { footerlogo } from "../Constant/Index";
import { Link } from "react-router-dom";
import { siteSettingapi } from "../network/Network";
import { SITESETTING } from "../redux/Slices/AuthSlice";
import { useDispatch } from "react-redux";

const Footer = () => {
	const dispatch = useDispatch();
	const [year, setYear] = useState(new Date().getFullYear());
	const [getSite, setGetSite] = useState("");

	useEffect(() => {
		setYear(new Date().getFullYear());
	}, []);

	// Site Setting APi
	useEffect(() => {
		siteSettingapi().then((res) => {
			dispatch(SITESETTING(res?.data));
			setGetSite(res?.data);
		});
	}, []);
	//   ======================
	return (
		<footer className="site-footer py-4 pt-5 dark-bg overflow-hidden position-relative">
			<div className="container">
				<div className="footer-wrap pt-5 position-relative">
					<div className="container">
						<div className="row">
							<div className="col-lg-11">
								<div className="row">
									<div className="col-md-4 col-sm-6 col-6">
										<div className="footer-logo-wrapper wow animate__animated animate__zoomIn">
											<figure className="footer-logo">
												<Link href="#" className="d-block w-fit">
													<img
														src={footerlogo}
														className="img-fluid light-image"
														alt=""
													/>
												</Link>
											</figure>
										</div>
										<div className="footer-para mt-3"></div>
										<div className="footer-lists">
											<ul className="list-unstyled d-flex ps-0 mb-0 gap-3">
												<Link
													to={getSite?.x_url}
													target="_blank"
													className="text-decoration-none extra-color-7 primary-regular-font level-8 d-flex align-items-center gap-3"
												>
													<span className="icon-badge md">
														<FontAwesomeIcon icon={faTwitter} />
													</span>
												</Link>
												<Link
													to={getSite?.facebook_url}
													target="_blank"
													className="text-decoration-none extra-color-7 primary-regular-font level-8 d-flex align-items-center gap-3"
												>
													<span className="icon-badge md">
														<FontAwesomeIcon icon={faFacebookF} />
													</span>
												</Link>
												<Link
													to={getSite?.instagram_url}
													target="_blank"
													className="text-decoration-none extra-color-7 primary-regular-font level-8 d-flex align-items-center gap-3"
												>
													<span className="icon-badge md">
														<FontAwesomeIcon icon={faInstagram} />
													</span>
												</Link>
												<Link
													to={getSite?.linkdin_url}
													target="_blank"
													className="text-decoration-none extra-color-7 primary-regular-font level-8 d-flex align-items-center gap-3"
												>
													<span className="icon-badge md">
														<FontAwesomeIcon icon={faLinkedinIn} />
													</span>
												</Link>
											</ul>
										</div>
									</div>
									<div className="col-md-2 col-sm-6 col-6">
										<div className="footer-lists-heading mb-4">
											<h5 className="level-6 primary-regular-font extra-color-7 priamry-color">
												Quick links
											</h5>
										</div>
										<div className="footer-lists">
											<ul className="footer-links p-0">
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link
														to="/about-us"
														className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover"
													>
														About Me
													</Link>
												</li>
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link
														to="/service"
														className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover"
													>
														Services
													</Link>
												</li>
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link
														to="/sign-in"
														className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover"
													>
														Appointment Booking
													</Link>
												</li>
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link
														to="/testimonials"
														className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover"
													>
														Testimonials
													</Link>
												</li>
											</ul>
										</div>
									</div>
									<div className="col-md-3 col-sm-6 col-6">
										<div className="footer-lists-heading mb-4">
											<h5 className="level-6 primary-regular-font extra-color-7 priamry-color">
												Legal
											</h5>
										</div>
										<div className="footer-lists">
											<ul className="footer-links p-0">
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link
														to="/terms-of-service"
														className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover"
													>
														Terms & Conditions
													</Link>
												</li>
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link
														to="/privacy-policy"
														className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover"
													>
														Privacy Policy
													</Link>
												</li>
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link
														to="/faqs"
														className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover"
													>
														FAQs
													</Link>
												</li>
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link
														to="/contact-us"
														className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover"
													>
														Contact Us
													</Link>
												</li>
											</ul>
										</div>
									</div>
									<div className="col-md-3 col-sm-6 col-6">
										<div className="footer-lists-heading mb-4">
											<h5 className="level-6 primary-regular-font extra-color-7 priamry-color">
												Info
											</h5>
										</div>
										<div className="footer-lists">
											<ul className="footer-links p-0">
												<li className="single-items mb-2 d-flex gap-4 align-items-center">
													<Link
														href="faqs"
														className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover"
													>
														<span className="pe-2">
															<FontAwesomeIcon icon={faPhone} />
														</span>
														{getSite?.contact_phone}
													</Link>
												</li>
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover">
														<span className="pe-2">
															<FontAwesomeIcon icon={faEnvelope} />
														</span>
														{getSite?.contact_email}
													</Link>
												</li>
												<li className="single-items mb-2 d-flex gap-2 align-items-center">
													<Link className="header-link header-link1 level-8 primary-regular-font extra-color-7 text-decoration-none link-hover">
														<span className="pe-2">
															<FontAwesomeIcon icon={faLocationDot} />
														</span>
														{getSite?.address}
													</Link>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="footer-bottom pt-3 pb-5">
					<p className="level-8 primary-regular-font extra-color-7 mb-0">
						© <span>{year}</span> — Copyright
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
